import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { AuthProvider } from "./shared/auth/AuthContext";
import { ToastProvider } from "./shared/ui-kit/Toast";

import "./shared/ui-kit/tokens.css";
import "./shared/ui-kit/global.css";
import { aplicarTema } from "./shared/ui-kit/useTheme";

aplicarTema();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
